import React from 'react';
import { SafeAreaView, View, ScrollView, Text } from 'react-native';
import PropTypes from 'prop-types';
import { t } from 'Locale';
import { Hr, ModalHeader, Icon } from 'LocalGluons';
import defaultStyles from './InfoPage.jss';

const InfoPage = ({ style, onClose, heading, message, children, mode, hideIcon }) => {
    const isLandscape = mode === 'landscape';

    return (
        <View style={{ flex: 1 }}>
            <View
                style={[
                    defaultStyles.container,
                    onClose ? defaultStyles.onCloseStyle : {},
                    style
                ]}
            >

                <ScrollView contentContainerStyle={defaultStyles.innerContainer} centerContent>
                    <View
                        style={[
                            defaultStyles.titleContainer,
                            isLandscape ? defaultStyles.titleContainerLandscape : {}
                        ]}
                    >
                        {!hideIcon && <Icon style={defaultStyles.infoIcon} name="warning_yellow" />}
                        <Text style={defaultStyles.title}>
                            {heading || t('COMMON.INFORMATION')}
                        </Text>
                    </View>
                    <Hr />
                    <Text style={defaultStyles.message}>{message}</Text>
                    {children}
                </ScrollView>
                {onClose && (
                    <ModalHeader
                        style={
                            isLandscape
                                ? { iconContainer: defaultStyles.iconContainerLandscape }
                                : {}
                        }
                        onPress={onClose}
                    />
                )}
            </View>
        </View>
    );
};

InfoPage.defaultProps = {
    style: {},
    children: [],
    onClose: null,
    heading: null,
    mode: 'portrait',
    hideIcon: false
};

InfoPage.propTypes = {
    style: PropTypes.shape({}),
    heading: PropTypes.string,
    message: PropTypes.string.isRequired,
    mode: PropTypes.string,
    children: PropTypes.any,
    onClose: PropTypes.func,
    hideIcon: PropTypes.bool
};

export default InfoPage;
